<template>
  <div class="px-5">
    <h3 class="grey--text pt-10 pb-5">
      {{ $t('transfer.details.invoices') }}
    </h3>

    <v-card outlined>
      <v-data-table
        :no-data-text="$t('table.noResults')"
        :headers="headers"
        :items="invoices"
        :mobile-breakpoint="20"
        :items-per-page="10"
        :footer-props="{
          'items-per-page-text': '',
          'items-per-page-options': [],
        }"
        single-expand
        disable-sort
        show-expand
      >
        <template v-slot:item.host="{ item }">
          <span v-if="host(item).id">
            <span @click="$emit('showHost', host(item).id)" class="primary--text clickable body-2 d-flex">
              {{ host(item).name }}
              <v-icon class="ml-1" color="primary" small>mdi-account-search</v-icon>
            </span>
            <span class="caption grey--text">
              {{  host(item).email }}
            </span>
          </span>
          <span v-else>---</span>
        </template>
        <template v-slot:item.real_estate="{ item }">
          <span v-html="customer(item)" />
        </template>
        <template v-slot:item.receiver="{ item }">
          {{ receiver(item) }}
        </template>
        <template v-slot:item.sender="{ item }">
          {{ sender(item) }}
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip :color="status(item).color" small>
            {{ status(item).status }}
          </v-chip>
        </template>
        <template v-slot:item.comment="{ item }">
          {{ comment(item) }}
        </template>
        <template v-slot:item.total="{ item }">
          {{ total(item) }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn v-if="hasFile(item)" @click="openInvoice(item)" small icon>
            <IconTooltip icon="mdi-eye-outline" :description="$t('hausefulInvoices.actions.show')" />
          </v-btn>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="content pl-13 pb-10">
            <v-card class="rounded-b-lg" outlined>
              <PaymentsTable :payments="payments(item)" />
            </v-card>
          </td>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { transferInvoicesHeaders } from '@/views/listHeaders/transferHeaders'
import { catalogMonetary, catalogCpfCnpj } from '@/util/catalog'
import { handleColors } from '@/util/colors'

import PaymentsTable from './components/PaymentsTable'
import IconTooltip from '@/components/IconTooltip'
import host from '../../store/modules/host'

export default {
  name: 'TransferInvoices',

  props: {
    transfer: {
      type: Object,
      required: true,
    },
  },

  components: {
    IconTooltip,
    PaymentsTable,
  },

  computed: {
    invoices() {
      return this.transfer.invoices ?? []
    },
  },

  methods: {
    host(item) {
      const hostId = item.host?.id ?? null
      const hostName = item.host?.name ?? '---'
      const hostEmail = item.host?.username ?? '---'

      return {
        id: hostId,
        name: hostName,
        email: hostEmail,
      }
    },

    customer(item) {
      const customer = item.real_estate?.name ?? '---'
      const customerDocument = item.real_estate?.cnpj ?? '---'

      return `
        <span class="body-2">${customer}</span>
        <span class="d-block caption grey--text">${catalogCpfCnpj(customerDocument)}</span>
      `
    },

    comment(item) {
      return item?.comment ?? '---'
    },

    sender(item) {
      return item.sender ? this.$t(`hausefulInvoices.${item.sender}`) : '---'
    },

    receiver(item) {
      return item.receiver ? this.$t(`hausefulInvoices.${item.receiver}`) : '---'
    },

    total(item) {
      return catalogMonetary(item.total ?? 0)
    },

    status(item) {
      return {
        color: handleColors(item.status),
        status: this.$t(`host.label.asaas.status.${item.status}`),
      }
    },

    hasFile(item) {
      return !!item?.file?.url
    },

    openInvoice(item) {
      const url = item?.file?.url
      window.open(url, '_blank')
    },

    payments(item) {
      return item.payment_list ?? []
    },
  },

  data() {
    return {
      headers: transferInvoicesHeaders,
    }
  }
}
</script>
